<template>
  <div>
    <section
      @click="onClickHandler"
      id="sectionId"
      class="d-flex flex-column body-content new-addendee-list attendee_List"
      style="background-color: #f1f3f4"
    >
      <div class="container-fluid">
        <!----top area-->
        <div class="row">
          <div
            class="
              col-md-6
              mb-22
              d-flex
              justify-content-start
              align-items-center
            "
          >
            <h1 id="headerText" class="page-head text-uppercase my-0">
              Way Finder
            </h1>

            
            
          </div>

            
          <!-----headdingg end--->
          <!-- mobile search button -->
          <div class="d-block d-md-none"></div>
          <!-- mobile search button end -->
          <div class="col-md-6 mob-pt-0">
            <div class="row justify-content-end mob-my-0"></div>
          </div>
        </div>
        <div class="wayfinder-filter-wrap">
          <div class="wayfinder-filter-drop-down">
            <select>
              <option>Avalon 3</option>
              <option>Avalon 4</option>
              <option>Avalon 5</option>
              <option>Court Room 1</option>
              <option>Court Room 2</option>
              <option>Cloak Room</option>
              <option>Indoor sports Arena</option>
            </select>
          </div>
          <div class="wayfinder-filter-drop-down">
            <select>
              <option>Avalon 3</option>
              <option>Avalon 4</option>
              <option>Avalon 5</option>
              <option>Court Room 1</option>
              <option>Court Room 2</option>
              <option>Cloak Room</option>
              <option>Indoor sports Arena</option>
            </select>
          </div>
          <div class="wayfinder-filter-drop-down">
            <select>
              <option>Avalon 3</option>
              <option>Avalon 4</option>
              <option>Avalon 5</option>
              <option>Court Room 1</option>
              <option>Court Room 2</option>
              <option>Cloak Room</option>
              <option>Indoor sports Arena</option>
            </select>
          </div>
          <div class="wayfinder-filter-btn">
            <span><img src="../assets/Images/icons/arrow_search.svg"/></span>
          </div>
          </div>
      </div>
      <div class="wayfinder-listing-wrap">
        <div class="container-fluid">
          <v-row class="d-none">
            <v-col md="3" sm="6" cols="12" >
              <div class="single-way-map">
                <div class="map-wrap">
                  <img src="../assets/Images/mapway_1.jpg"/>
                  <div class="map-zoomin-wrap">
                    <img src="../assets/Images/icons/zoom-in.svg"/>
                  </div>
                </div>
                <div class="map-floor-name">
                  <h3>Floor One</h3>
                </div>
              </div>
            </v-col>
            <v-col md="3" sm="6" cols="12" >
              <div class="single-way-map" >
                <div class="map-wrap">
                  <img src="../assets/Images/mapway_1.jpg"/>
                  <div class="map-zoomin-wrap">
                    <img src="../assets/Images/icons/zoom-in.svg"/>
                  </div>
                </div>
                <div class="map-floor-name">
                  <h3>Floor Two</h3>
                </div>
              </div>
            </v-col>
            <v-col md="3" sm="6" cols="12" >
              <div class="single-way-map">
                <div class="map-wrap">
                  <img src="../assets/Images/mapway3.jpg"/>
                  <div class="map-zoomin-wrap">
                    <img src="../assets/Images/icons/zoom-in.svg"/>
                  </div>
                </div>
                <div class="map-floor-name">
                  <h3>Africa Floor One</h3>
                </div>
              </div>
            </v-col>
            <v-col md="3" sm="6" cols="12" >
              <div class="single-way-map">
                <div class="map-wrap">
                  <img src="../assets/Images/mapway4.jpg"/>
                  <div class="map-zoomin-wrap">
                    <img src="../assets/Images/icons/zoom-in.svg"/>
                  </div>
                </div>
                <div class="map-floor-name">
                  <h3>Africa Ground One</h3>
                </div>
              </div>
            </v-col>

            <v-col md="3" sm="6" cols="12" >
              <div class="single-way-map">
                <div class="map-wrap">
                  <img src="../assets/Images/mapway_1.jpg"/>
                  <div class="map-zoomin-wrap">
                    <img src="../assets/Images/icons/zoom-in.svg"/>
                  </div>
                </div>
                <div class="map-floor-name">
                  <h3>Floor One</h3>
                </div>
              </div>
            </v-col>
            <v-col md="3" sm="6" cols="12" >
              <div class="single-way-map">
                <div class="map-wrap">
                  <img src="../assets/Images/mapway_1.jpg"/>
                  <div class="map-zoomin-wrap">
                    <img src="../assets/Images/icons/zoom-in.svg"/>
                  </div>
                </div>
                <div class="map-floor-name">
                  <h3>Floor Two</h3>
                </div>
              </div>
            </v-col>
            <v-col md="3" sm="6" cols="12" >
              <div class="single-way-map">
                <div class="map-wrap">
                  <img src="../assets/Images/mapway3.jpg"/>
                  <div class="map-zoomin-wrap">
                    <img src="../assets/Images/icons/zoom-in.svg"/>
                  </div>
                </div>
                <div class="map-floor-name">
                  <h3>Africa Floor One</h3>
                </div>
              </div>
            </v-col>
            <v-col md="3" sm="6" cols="12" >
              <div class="single-way-map">
                <div class="map-wrap">
                  <img src="../assets/Images/mapway4.jpg"/>
                  <div class="map-zoomin-wrap">
                    <img src="../assets/Images/icons/zoom-in.svg"/>
                  </div>
                </div>
                <div class="map-floor-name">
                  <h3>Africa Ground One</h3>
                </div>
              </div>
            </v-col>
          </v-row>
          <div class="large-way-map-row">
            <div class="large-waymap-header d-flex justify-content-between align-items-center">
              <div class="backmaplist d-flex justify-content-start align-items-center">
                <img src="../assets/Images/chat-assets/back-to-list-dark.svg" height="20px" width="20px"/>
                <p>Back</p>
              </div>
              <div class="map-floor-head">
                <h3>Floor One</h3>
              </div>
              <div></div>
            </div>
            <div class="way-map-inner-wrap d-flex justify-content-center">
              <img src="../assets/Images/large-waymap.jpg" />
            </div>
          </div>   
        </div>
      </div>
    </section>

    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
        display: none;
      "
    >
      <div class="loader">
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>
<style>
/*--------------------Mobile---------------------*/
@media only screen and (max-width: 767px) {
  .custom-filter-right {
    left: 0;
    z-index: 9;
  }
}
</style>
<script>
//import Vue from "vue";
//import db from "../components/firebaseInit";
//import AttendeeDetails from "@/components/AttendeeDetails.vue";
import jQuery from "jquery";
let $ = jQuery;
import analytics from "@/components/Analytics";
import router from "../router";
import axios from "axios";
import APIs from "@/components/APIInit";
//import moment from "moment";
//import store from "../store";
import common from "@/common";
import { bus } from "@/main";

let lastVisible = null;
let hasMore = true;
var self;
//let interval;

export default {
  components: {},
  data() {
    return {
      activeUsersInsideEvent: [],
      imageExists: null,
      isBookmarked: false,
      currentAttendee: null,
      attendeeEvent: null,
      ShowEmailandPhone: false,
      EnableAttendeeDBsearch: false,
      //headerText: this.$t("attendee.attendees"),
      headerText: "Business Card",
      ShowMeetingButton: false,
      ShowSendMessageButton: false,
      ShowFilter: false,
      ShowSearch: false,
      AttendeeSettingsLoaded: false,
      loggedInUseID: "",
      pageSize: 50,
      pageIndex: 0,
      pageCount: 1,
      totalRecords: 1,
      lastVisible: null,
      attendeeData: [],
      speakersList: [],
      ShowSpeakerInAttendee: true,
      searchtext: "",
      IsShowNoDataFound: false,
      IsLoading: true,
      IsShowCancelButton: false,
      IsSearchMode: false,
      GlobalKeysData: {
        IsBroadcastInNewTab: 1,
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
      clientID: this.$store.getters.getClient[0].id,
      eventId: null,
      eventcollection: "",
      textColor: "black",
      //SlotAvailable: [],
      APIs: APIs,
      AttendeeListSortBy: "Name",
      AttendeeListSorDirection: "asc",
      filterDisplayState: false,
      DynamicFilterOptions: [],
      DynamicFieldsExcludeOptions: [],
      StaticFieldsExcludeOptions: {},
      hasFilterOrSearch: false,
      regTypes: [],
      showAttendeeLegend: false,
      ShowFilterQuery: false,
      ShowSearchQuery: false,
      requestMeetingKey: 0,
      meetingRestrictionEnabled: false,
      restrictedRegistrationTypes: [],
      restrictedAttendeeIDs: [],
      ExcludeCountriesFromFilter: [],
      myRegistrationType: "",
      isScrolled: false,
      currentAttendeeName: "",
      selectedLegendRegType: "All",
      userInformation: [
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
        { username: "x" },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    self = this;
    var obj = JSON.parse(window.localStorage.getItem("my-app"));

    if (obj && obj.user && obj.user.length > 0) {
      self.loggedInUseID = obj.user[0].id;
    }
    if (obj && obj.eventcollectionname) {
      self.eventcollection = obj.eventcollectionname;
    }

    bus.$on("activeUsersList", (data) => {
      self.activeUsersInsideEvent = data;
    });
  },
  beforeDestroy() {
    //window.removeEventListener("scroll", this.onScrollHandler);
    hasMore = true;
    lastVisible = null;
    self.attendeeData = [];
    self.searchtext = "";
  },
  beforeUpdate() {
    //alert("beforeUpdate");
    //self.attendeeData.sort(function(a, b) {
    //  let aName = a[self.AttendeeListSortBy].trim().toLowerCase();
    //  let bName = b[self.AttendeeListSortBy].trim().toLowerCase();
    //  if (aName < bName) {
    //    return -1;
    //  }
    //  if (aName > bName) {
    //    return 1;
    //  }
    //  return 0;
    //});
  },
  async mounted() {
    //this.getAttendeeDetails();
    //document.body.addEventListener("scroll", this.scroll);
    //Do not Delete These Method Calls
    //self.createDynamicFieldFilterOptions();
    //self.createDynamicFieldDisplayOptions();
  },

  methods: {
    getAttendeeLoggedInStatus(attendeeId) {
      if (self.activeUsersInsideEvent.includes(attendeeId)) {
        return true;
      } else {
        return false;
      }
    },
    filterAttendeeByRegType(regType) {
      $("#RegistrationType_RegistrationType input[type=radio]").prop(
        "checked",
        false
      );
      if (self.selectedLegendRegType != regType) {
        $(
          "#RegistrationType_RegistrationType input[type=radio][value='" +
            regType +
            "']"
        ).prop("checked", true);
      }
      //if (regType == "") {
      //  self.selectedLegendRegType = "";
      //}
      if (self.selectedLegendRegType != regType) {
        self.selectedLegendRegType = regType;
        self.filterAttendee();
      }
    },
    scrollScreen() {
      var scrollingElement = document.scrollingElement || document.body;
      if (this.isScrolled == false) {
        $(scrollingElement).animate(
          {
            scrollTop: document.body.scrollHeight,
          },
          500
        );
        $("#arrow-icon").addClass("arrow-up");
        this.isScrolled = true;
      } else {
        $(scrollingElement).animate(
          {
            scrollTop: 0,
          },
          500
        );
        $("#arrow-icon").removeClass("arrow-up");
        this.isScrolled = false;
      }
    },
    addAttendeeBookMark(attendeeId, Name, Image, isBookmarked, e) {
      e.stopPropagation();
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 3,
          entityName: Name,
          entityImage: Image ? Image : "",
          entityId: attendeeId,
          entityLink: this.$route.path,
        },
      };
      if (isBookmarked) {
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == attendeeId;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = false;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
            self.showSnackbar("Bookmark removed successfully.", "info", "top");
          })
          .catch(() => {});
      } else {
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == attendeeId;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = true;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
            self.showSnackbar("Bookmark added successfully.", "info", "top");
          })
          .catch(() => {});
      }
    },
    async addBookMark() {
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 3,
          entityName: this.currentAttendee.Name,
          entityImage: this.currentAttendee.Image
            ? this.currentAttendee.Image
            : "",
          entityId: this.currentAttendee.id,
          entityLink: this.$route.path,
        },
      };
      if (this.isBookmarked) {
        this.isBookmarked = false;
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            self.isBookmarked = false;
            debugger;
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == self.currentAttendee.id;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = false;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
          })
          .catch(() => {
            self.isBookmarked = true;
          });
      } else {
        self.isBookmarked = true;
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            debugger;
            self.isBookmarked = true;
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == self.currentAttendee.id;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = true;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
          })
          .catch(() => {
            self.isBookmarked = false;
          });
      }
    },
    async getAttendeeDetails() {
      let self = this;
      //window.addEventListener("scroll", this.onScrollHandler);
      hasMore = true;
      lastVisible = null;

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //window.addEventListener("scroll", this.scroll);
      //document.body.addEventListener("scroll", this.scroll);
      self.getDynamicFieldFilterOptions();
      self.getDynamicFieldDisplayOptions();

      if (obj && obj.eventid) {
        self.eventId = obj.eventid;
      }

      self.attendeeData = [];
      //self.displayAttendees();
      self.searchtext = "";

      //--------get  setting---------------------------------------------------------------------------------

      //-------------dynamic font selection --------------------------------------
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
      //-------------dynamic font selection --------------------------------------

      //-------------------FAVICONJOB------------------------------------------------------------

      if (obj.branding[0].favicon != undefined) {
        if (obj.branding[0].favicon != "") {
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = self.getCDNUrl(obj.branding[0].favicon);
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }
      //----------------------------------------------------------------------------------
      /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          obj.eventcollectionname + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          if (brandingData.data.EventInfo != undefined) {
            if (brandingData.data.EventInfo.BodyTextColor != undefined) {
              self.textColor = brandingData.data.EventInfo.BodyTextColor;
            } else {
              self.textColor = "black !important";
            }
          } else {
            self.textColor = "black !important";
          }
          $("#headerText").css("color", self.textColor);
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }

      //------------------------------------------------------------------------------

      $("#btnAddUserView").click();
      if ($("#imgBanner")) {
        $("#imgBanner").attr(
          "src",
          self.getCDNUrl(obj.EventBranding[0].banner)
        );
      }
      common.toggleTopMenu(true);
      common.toggleLeftMenu(true);
      //$("#topmenu").show();
      //$("#leftmenu").show();

      //-------Page Title-------------
      //db.collection(obj.eventcollectionname)
      //  .doc("Menu")
      //  .get()
      //  .then((doc) => {
      //    var data = doc.data();
      //    $.each(data.AllMenu, function (key, value) {
      //      if (value.GroupID != 99) {
      //        if (value.Name == "Attendees") {
      //          let headerText = "";
      //          if (self.$store.state.locale == "English") {
      //            headerText = value.DisplayLabel;
      //          } else if (self.$store.state.locale == "German") {
      //            headerText = value.DisplayLabel_de;
      //          } else if (self.$store.state.locale == "French") {
      //            headerText = value.DisplayLabel_fr;
      //          } else if (self.$store.state.locale == "Chinese") {
      //            headerText = value.DisplayLabel_zh;
      //          } else {
      //            headerText = value.DisplayLabel;
      //          }
      //          if (headerText) {
      //            self.headerText = headerText;
      //          }
      //          document.title = self.headerText + " - " + obj.eventname;
      //          // document.getElementById("headerText").innerText =
      //          //   self.headerText;
      //        }
      //      }
      //    });
      //    $.each(data.LeftMenu, function (key, value) {
      //      if (value.GroupID != 99) {
      //        if (value.Name == "Attendees") {
      //          let headerText = "";
      //          if (self.$store.state.locale == "English") {
      //            headerText = value.DisplayLabel;
      //          } else if (self.$store.state.locale == "German") {
      //            headerText = value.DisplayLabel_de;
      //          } else if (self.$store.state.locale == "French") {
      //            headerText = value.DisplayLabel_fr;
      //          } else if (self.$store.state.locale == "Chinese") {
      //            headerText = value.DisplayLabel_zh;
      //          } else {
      //            headerText = value.DisplayLabel;
      //          }
      //          if (headerText) {
      //            self.headerText = headerText;
      //          }
      //          document.title = self.headerText + " - " + obj.eventname;
      //          // document.getElementById("headerText").innerText =
      //          //   self.headerText;
      //        }
      //      }
      //    });
      //  });
      //-------Page Title-------------

      /*   if ($("#ulLeftMenu li").length > 0) {
      $("#leftMenuParent").show();
      $("#leftmenu").show();
    } else {
      $("#leftMenuParent").hide();
      $("#leftmenu").hide();
    }*/
      //
      //this.OnIdUrl(self.attendeeData);
      //self.scroll();
      $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
      $("#sectionId").css(
        "background-image",
        "url(" + self.getCDNUrl(obj.EventBranding[0].eventBGImage) + ")"
      );
      self.fetchRegistrationType();

      if (self.$route.query.filter != undefined) {
        if (
          self.$route.query.filter == true ||
          self.$route.query.filter == "true"
        ) {
          self.ShowFilterQuery = true;
        }
      }

      if (self.$route.query.search != undefined) {
        if (
          self.$route.query.search == true ||
          self.$route.query.search == "true"
        ) {
          self.ShowSearchQuery = true;
        }
      }
    },
    toggleFilter(e) {
      self.filterDisplayState = !self.filterDisplayState;
      e.stopPropagation();
    },
    hideFilter() {
      self.filterDisplayState = false;
    },
    makeHtmlElementId(id) {
      id = id.replace("a_DynamicFields", "");
      return id;
    },
    preventHideFilter() {
      //e.stopPropagation();
    },
    getDates: function (startDate, endDate) {
      var dates = [],
        currentDate = startDate,
        addDays = function (days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
        };
      dates.push(currentDate);
      while (currentDate <= endDate) {
        currentDate = addDays.call(currentDate, 1);
        dates.push(currentDate);
      }

      return dates;
    },
    searchAttendee: function () {
      //$("#dvAttendeeWrapper").html("");
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.pageCount = 0;
      hasMore = true;
      lastVisible = null;
      self.attendeeData = [];
      self.applyFilter();
      //$("#dvAttendeeWrapper").html("");
    },
    closeModal: function () {
      $("#myModal2").removeClass("show");
      $("#myModal2").hide();
      // $("#dvBackDrop").hide();
      // $("#dvBackDrop").removeClass("show");
      router.push("/attendee");
    },
    displayAttendees(requestData) {
      self.showLoader();
      console.log(hasMore);
      console.log(lastVisible);

      //var search = [];
      //let searchText = self.searchtext.trim().toLowerCase();
      //if (searchText) {
      //  search.push({
      //    key: "Name",
      //    operator: "LIKE",
      //    value: searchText,
      //  });
      //  search.push({
      //    key: "Company",
      //    operator: "LIKE",
      //    value: searchText,
      //  });
      //  search.push({
      //    key: "Designation",
      //    operator: "LIKE",
      //    value: searchText,
      //  });
      //  //search.push({
      //  //  key: "Tags",
      //  //  operator: "array-contains-any",
      //  //  value: searchText,
      //  //});
      //}
      self.pageIndex++;
      //requestData.search = search;
      requestData.pagination = {
        Page: self.pageIndex,
        PageSize: self.pageSize,
      };
      requestData.origin = "WEB";
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };
      let keys = {
        instanceId: "OA_UAT",
        clientId: self.clientID, // "C1591205467009",
        eventId: self.eventId, //"E1591206650065",
      };
      let rqstData = {};
      //if (requestData.filter.length > 0) {
      rqstData = {
        key: keys,
        data: requestData,
      };
      //} else {
      //  rqstData = {
      //    key: keys,
      //    data: {
      //      pagination: {
      //        Page: self.pageIndex,
      //        PageSize: self.pageSize,
      //      },
      //    },
      //  };
      //}
      //pageSize: 1000,
      //pageIndex: 1,

      axios
        .post(self.APIs.AttendeeSearch, rqstData, {
          headers: headers,
        })
        .then((responseData) => {
          self.hideLoader();
          if (responseData && responseData.data && responseData.data.result) {
            let data = responseData.data.result;
            self.pageCount = responseData.data.pagination.TotalPages;
            //self.attendeeData = [];
            for (var i = 0; i < data.length; i++) {
              var filteredRows = self.attendeeData.filter(function (value) {
                return (
                  value.id ==
                  (data[i].AttendeeId != undefined ? data[i].AttendeeId : "")
                );
              });

              if (filteredRows.length == 0) {
                //if (data[i].AttendeeId == "51024") {
                //  console.log(data[i]);
                //  alert(data[i].IsPublished);
                //  debugger;
                //}
                if (
                  data[i].ShowInCMSAttendeeList == 1 ||
                  data[i].ShowInCMSAttendeeList == undefined
                ) {
                  var objAttendee = {
                    id:
                      data[i].AttendeeId != undefined
                        ? data[i].AttendeeId
                        : "0",
                    attendeeId:
                      data[i].AttendeeId != undefined
                        ? data[i].AttendeeId
                        : "0",
                    Name:
                      (data[i].FirstName != undefined
                        ? data[i].FirstName
                        : "") +
                      " " +
                      (data[i].LastName != undefined ? data[i].LastName : ""),
                    FirstName:
                      data[i].FirstName != undefined ? data[i].FirstName : "",
                    LastName:
                      data[i].LastName != undefined ? data[i].LastName : "",
                    Email: data[i].Email != undefined ? data[i].Email : "",
                    Image:
                      data[i].ProfilePictureURL != undefined
                        ? self.getCDNUrl(data[i].ProfilePictureURL)
                        : "",
                    Title:
                      data[i].Designation != undefined
                        ? data[i].Designation
                        : "",
                    Company:
                      data[i].Company != undefined ? data[i].Company : "",
                    Profile:
                      data[i].Profile != undefined ? data[i].Profile : "",
                    Phone: data[i].Phone != undefined ? data[i].Phone : "",
                    Website:
                      data[i].Website != undefined ? data[i].Website : "",
                    SocialLinks:
                      data[i].SocialLinks != undefined
                        ? data[i].SocialLinks
                        : [],
                    Initials: common.getInitials(
                      (data[i].FirstName != undefined
                        ? data[i].FirstName
                        : "") +
                        " " +
                        (data[i].LastName != undefined ? data[i].LastName : "")
                    ),

                    RegistrationType: data[i].RegistrationType
                      ? data[i].RegistrationType
                      : "",
                    DynamicFields: data[i].DynamicFields
                      ? data[i].DynamicFields
                      : [],
                    Tags: data[i].Tags ? data[i].Tags : "",
                    IsPublished:
                      data[i].IsPublished != undefined
                        ? data[i].IsPublished
                        : true,
                    HideInList: data[i].HideInList ? data[i].HideInList : false,
                  };
                  objAttendee.FirstName = objAttendee.FirstName.trim();
                  objAttendee.LastName = objAttendee.LastName.trim();
                  objAttendee.Name =
                    objAttendee.FirstName + " " + objAttendee.LastName;

                  var sLinks = objAttendee.SocialLinks;
                  sLinks.forEach((sLink) => {
                    if (sLink["Facebook"] != undefined) {
                      objAttendee.Facebook =
                        sLink["Facebook"] == undefined ? "" : sLink["Facebook"];
                    }
                    if (sLink["Twitter"] != undefined) {
                      objAttendee.Twitter =
                        sLink["Twitter"] == undefined ? "" : sLink["Twitter"];
                    }
                    if (sLink["LinkedIn"] != undefined) {
                      objAttendee.LinkedIn =
                        sLink["LinkedIn"] == undefined ? "" : sLink["LinkedIn"];
                    }
                    if (sLink["GooglePlus"] != undefined) {
                      objAttendee.GooglePlus =
                        sLink["GooglePlus"] == undefined
                          ? ""
                          : sLink["GooglePlus"];
                    }
                  });
                  objAttendee.isOnline = self.getAttendeeLoggedInStatus(
                    data[i].AttendeeId
                  );
                  //if (objAttendee.attendeeId == "221000") {
                  //  alert(objAttendee.IsPublished);
                  //  alert(objAttendee.HideFromList);
                  //}
                  //let flag = false;
                  //if (ShowSpeakerInAttendee == false) {
                  //  if (speakersList2.indexOf(objAttendee.AttendeeId) < 0) {
                  //    flag = true;
                  //  }
                  //} else {
                  //  flag = true;
                  //}

                  //if (flag) {
                  self.attendeeData.push(objAttendee);
                  //}
                }
              }
            }
            //if (self.attendeeData.length > 0) {
            //  self.IsShowNoDataFound = false;
            //} else {
            //  self.IsShowNoDataFound = true;
            //}
          }
        })
        .catch((error) => {
          self.hideLoader();
          //
          //self.IsShowNoDataFound = true;
          console.log("Error:" + error);

          return false;
        });
      // lastVisible = null;
    },
    getArrayTrimString: function (tags) {
      var RetArray = [];
      $.each(tags.split(","), function () {
        RetArray.push($.trim(this));
      });
      return RetArray;
    },
    scroll: function () {
      //if (self.searchtext.length <= 0) {
      //if (!self.hasFilterOrSearch) {
      //window.onscroll = () => {
      //alert("scroll");
      //if (!self.IsSearchMode) {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight + 1 >=
        document.documentElement.offsetHeight;
      //alert(document.getElementsByClassName("v-main")[0].scrollTop);
      //debugger;
      //alert(
      //  "document.documentElement.scrollTop: " +
      //    document.documentElement.scrollTop
      //);
      //alert("window.innerHeight: " + window.innerHeight);
      //alert(
      //  "document.documentElement.offsetHeight: " +
      //    document.documentElement.offsetHeight
      //);
      //alert(bottomOfWindow);
      if (self.AttendeeSettingsLoaded && bottomOfWindow) {
        //alert("scroll");
        //if (self.searchtext.trim() == "") {
        //if (!self.hasFilterOrSearch) {
        //self.displayAttendees();
        //self.applyFilter();
        //}
      }
      //}
      //};
      //}
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
      self.IsLoading = true;
    },
    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(self.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
      self.IsLoading = false;
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              self.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                self.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          self.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            self.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      self.AddAnalitics(event, "click");
      //self.hideFilter();
    },
    mob_alist_search() {
      $("#mob_att_search").css("display", "flex");
      $(".mob_search_button").css("opacity", "0 ");
    },
  },
};
</script>
<style>
.wayfinder-filter-wrap {width: 900px; background: #fff; padding: 15px; border-radius: 50px; display: flex;justify-content: flex-start;align-items: center;margin: 0 auto;}
.wayfinder-filter-drop-down {width: 30%; height: 50px; border: 1px solid #dfdfdf; margin-right: 15px; border-radius: 50px; display: flex; align-items: center; padding-left: 32px;}
.wayfinder-filter-drop-down:first-child{background: url(../assets/Images/icons/floor.svg) no-repeat  left 10px center / 15px;}
.wayfinder-filter-drop-down:nth-child(2){background: url(../assets/Images/icons/source.svg) no-repeat  left 10px center / 15px;}
.wayfinder-filter-drop-down:nth-child(3){background: url(../assets/Images/icons/destination.svg) no-repeat  left 10px center / 15px;}
.wayfinder-filter-btn span {display: inline-block; cursor: pointer;}
.wayfinder-filter-drop-down select {width: 100%; height: 50px;  border-top-right-radius: 50px; border-bottom-right-radius: 50px; outline: none !important; color: #a8a8a8; font-weight: 400; font-size: 16px;cursor: pointer;background: url(../assets/Images/icons/down-arrow-ash.svg) no-repeat right 15px center / 13px;}
.wayfinder-listing-wrap{background: #fff; padding: 15px; margin-top: 28px;}
.single-way-map {min-height: 380px;overflow: hidden; border: 1px solid #dfdfdf; border-radius: 15px; display: flex; flex-direction: column; justify-content: center; align-items: center;}
.map-wrap {flex: 2;width: 100%; display: flex; justify-content: center;align-items: center;}
.map-floor-name {width: 100%;  height: 80px; background: #f1f5f8; display: flex; justify-content: center; align-items: center;}
.map-wrap{position: relative;}
.map-zoomin-wrap {position: absolute; background: rgba(0,0,0,0.5); height: 100%; width: 100%;  justify-content: center; align-items: center; cursor: pointer;display: none;}
.map-wrap:hover .map-zoomin-wrap{display: flex;}
.map-floor-name h3{margin: 0; color: #1c1d26; font-weight: 600; font-size: 24px;}
.backmaplist p {margin: 0; font-size: 16px; font-weight: 400; margin-left: 11px;}
.map-floor-head h3{color: #1c1d26; font-weight: 600; font-size: 20px; margin: 0;}
.way-map-inner-wrap{padding-top: 50px;}
</style>
